import {Lozenge} from "./core/Lozenge/Lozenge";
import React from "react";

export const LoggedInUserLozenge = ({loggedInUser}) => {
    return loggedInUser ? <Lozenge compact={true} color="gray" title="You" /> : null;
}
